import { MENU_JIAMENG_STATS, JIAMENG_STATS_PATH } from '@constant'

export default {
  key: MENU_JIAMENG_STATS,
  id: '',
  title: '数据',
  icon: 'icon-yingxiao',
  link: JIAMENG_STATS_PATH
}
